export const SOCIAL_LOGIN_PATH = '/';
export const USERNAME_LOGIN_PATH = '/username';
export const USERNAME_SIGNUP_PATH = '/username/signup';
export const FORGOT_PASSWORD_ROUTE = '/forgot';
export const RESET_PASSWORD_ROUTE = '/reset';
